import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {REQUEST_DEMO} from "@/lib/featureFlags.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

export const CtaComparisonButtonGroup = () => {
  const {userHasFeature} = useCurrentUserContext();
  return (
    <div className={"d-flex gap-2"}>
      <Button as={Link} variant={"secondary"} to={`/contact`} target="_blank">
        Contact Us
      </Button>
      {userHasFeature(REQUEST_DEMO) && (
        <Button as={"a"} variant={"secondary"} href={`${URL_ORIGINAL_WEBSITE}/request-demo`} target="_blank">
          Book a Demo
        </Button>
      )}
      <Button as={"a"} variant={"secondary"} href={`${URL_ORIGINAL_WEBSITE}/pricing#comparison-table`} target="_blank">
        Compare All Features
      </Button>
    </div>
  );
};
